import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getInputs = async ({ commit }) => {
  let url = `/inputs/selectable`;

  await connection.get(url)
    .then(res => {
      const inputs = res.data.data;
      commit('setInputsSelectable', inputs);
    }).catch(err => {
      console.log('error', err);
    });
}

export const loadInputs = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setInputIsLoading', true);
    let url = `/inputs`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const inputs = res.data.data;
        commit('setInputs', inputs);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setInputsPaginated', res.data);
        commit('setInputIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setInputIsLoading', false);
      });
}

export const inputById = async ({ commit }, id) => {
  commit('setInputIsLoading', true);
  await connection.get(`/inputs/${id}`)
    .then(res => {
      commit('setInputDetail', res.data.data);
      commit('setInputIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputIsLoading', false);
    });
}

export const storeInput = async ({ commit }, input) => {
  commit('setInputIsCreating', true);
  await connection.post(`/inputs/create`, input)
    .then(res => {
      commit('saveNewInputs', res.data);
      commit('setInputIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputIsCreating', false);
    });
}

export const updateInput = async ({ commit }, input ) => {
  commit('setInputIsUpdating', true);
  await connection.put(`/inputs/${input.id}/update`, input)
    .then(res => {
      commit('saveUpdatedInput', res.data);
      commit('setInputIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputIsUpdating', false);
    });
}

export const deleteInput = async ({ commit }, input) => {
  commit('setInputIsDeleting', true);
  await connection.delete(`/inputs/${input.id}/cancel`)
    .then(res => {
      commit('setDeleteInput', res.data);
      commit('setInputIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputIsDeleting', false);
    });
}

export const cancelInput = async ({ commit }, input) => {
  commit('setInputIsCancelating', true);
  await connection.post(`/inputs/cancel`, input)
    .then(res => {
      commit('setCancelInput', res.data);
      commit('setInputIsCancelating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputIsCancelating', false);
    });
}